import { createAction } from "@reduxjs/toolkit";

const resetStore = createAction("resetStore");
const logout = createAction("logout");

const globalActions = { resetStore, logout };

export default globalActions;
